import { Brand } from 'library/ts/model/enums/Brand';

import { getForceBrandFromQuery } from './ForceBrandQuery';

/**
 * @copyright © Paramount Streaming
 * @description Resolves Smart Tag brand from optional URL `forceBrand`, first registry entry
 * (`params.CONTENT.partner`), or `document.body` CSS classes. Defaults to {@link Brand.PPLUS}.
 */
export function resolveSmartTagBrand(): Brand {
	try {
		const forced = getForceBrandFromQuery();
		if ( forced === 'pplus' ) {
			return Brand.PPLUS;
		}
		if ( forced === 'plutotv' ) {
			return Brand.PLUTOTV;
		}
		if ( forced === 'cbs' ) {
			return Brand.CBS;
		}

		const registry = window?.SmartTag?.registry;
		if ( registry ) {
			const uuids = Object.keys( registry );
			if ( uuids.length > 0 ) {
				const params = registry[ uuids[ 0 ] ]?.params;
				const partner = params?.CONTENT?.partner;
				if ( partner ) {
					const partnerLower = String( partner ).toLowerCase();
					if ( partnerLower.includes( 'pplus' ) || partnerLower.includes( 'paramount' ) ) {
						return Brand.PPLUS;
					}
					if ( partnerLower.includes( 'pluto' ) ) {
						return Brand.PLUTOTV;
					}
					if ( partnerLower === 'cbs' ) {
						return Brand.CBS;
					}
					return Brand.PPLUS;
				}
			}
		}
		const body = document?.body;
		if ( body ) {
			if ( body.classList.contains( 'brand-pplus' ) || body.classList.contains( 'pplus' ) ) {
				return Brand.PPLUS;
			}
			if ( body.classList.contains( 'brand-plutotv' ) || body.classList.contains( 'plutotv' ) ||
				body.classList.contains( 'brand-pluto' ) || body.classList.contains( 'pluto' ) ) {
				return Brand.PLUTOTV;
			}
			if ( body.classList.contains( 'brand-cbs' ) || body.classList.contains( 'cbs' ) ) {
				return Brand.CBS;
			}
		}
	} catch ( e ) {
		// Silently fail
	}
	return Brand.PPLUS;
}